import React, { useState } from "react";
import {
  BoxFullCTA,
  PSSubmitCTAWrapper,
  SubmitCTA,
} from "./PSSubmitCTASection.style";
import { PACKSLIP_CTA_TYPE } from "../../../constants";
import { message } from "antd";
import { newApiCallHandler } from "../../../services/packslip.service";
import { CheckerService_URL } from "../../../redux/Url";
import { BsCheckCircleFill, BsExclamationCircleFill } from "react-icons/bs";

const PSSubmitCTASection = (props) => {
  const [isLoading, setLoading] = useState(false);
  const handlePostCta = (type = PACKSLIP_CTA_TYPE.SUBMIT) => {
    setLoading(true);
    newApiCallHandler({
      params: {
        boxFull: type === PACKSLIP_CTA_TYPE.BOXFULL ? true : false,
        transferOrderId: props.transferOrderId,
        destinationBox: props.destinationBox,
        sourceBox: props.sourceBox,
        packed: type === PACKSLIP_CTA_TYPE.SUBMIT ? true : false,
      },
      data: props.medicineList,
      method: "POST",
      url: `${CheckerService_URL}/packing/boxes/products`,
      onSuccess: (res, error) => {
        if (error) {
          console.log(error);
          message.error(error);
          return;
        }
        props.handlePostCTA(type, res);
      },
      onFailure: (err) => {
        console.log(err);
        message.error(err);
      },
    });
  };

  const enableSubmit = props?.medicineList?.length
    ? props?.medicineList.every((item) => item.checked)
    : false;
  const enableBoxFull = props?.medicineList?.length
    ? props?.medicineList?.some((item) => {
        if (item.pendingQty !== item.totalQty) {
          return true;
        }
        return false;
      })
    : false;

  return (
    <PSSubmitCTAWrapper>
      <BoxFullCTA
        // disabled={isLoading || !enableBoxFull}
        disabled={isLoading}
        onClick={() => handlePostCta(PACKSLIP_CTA_TYPE.BOXFULL)}
      >
        <BsExclamationCircleFill /> Box Full
      </BoxFullCTA>
      <SubmitCTA
        disabled={isLoading || !enableSubmit}
        onClick={() => handlePostCta(PACKSLIP_CTA_TYPE.SUBMIT)}
        className="submit"
      >
        <BsCheckCircleFill /> Submit
      </SubmitCTA>
    </PSSubmitCTAWrapper>
  );
};

export default PSSubmitCTASection;
